var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFuelingCompleted = function SvgFuelingCompleted(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 76,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.717.802a5.989 5.989 0 015.989 0l27.722 16.006a5.989 5.989 0 012.995 5.186v32.012a5.989 5.989 0 01-2.995 5.186L38.706 75.198a5.989 5.989 0 01-5.989 0L4.994 59.192A5.989 5.989 0 012 54.006V21.994a5.989 5.989 0 012.994-5.186L32.717.802z",
    fill: "#FFB877"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 2.76a5.674 5.674 0 015.674 0l26.263 15.163a5.673 5.673 0 012.837 4.914v30.326c0 2.027-1.081 3.9-2.837 4.914L38.774 73.24a5.673 5.673 0 01-5.674 0L6.837 58.077A5.673 5.673 0 014 53.163V22.837c0-2.027 1.081-3.9 2.837-4.914L33.1 2.76z",
    fill: "#D98F00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 64,
    height: 72
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 2.76a5.674 5.674 0 015.674 0l26.263 15.163a5.673 5.673 0 012.837 4.914v30.326c0 2.027-1.081 3.9-2.837 4.914L38.774 73.24a5.673 5.673 0 01-5.674 0L6.837 58.077A5.673 5.673 0 014 53.163V22.837c0-2.027 1.081-3.9 2.837-4.914L33.1 2.76z",
    fill: "#EE7984"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 28c0-5.523 4.477-10 10-10h25c5.523 0 10 4.477 10 10v40a8 8 0 01-8 8H27a8 8 0 01-8-8V28z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.29 47.466zm-.01 42.937c-2.546.008-4.609-.968-5.99-2.748-1.384-1.776-2.013-4.232-2.01-6.88.009-4.25 1.544-9.141 4.393-13.737 2.686-4.285 3.985-10.88 3.972-15.692.001-1.54-.13-2.892-.354-3.881l2.116-.747c.299 1.329.437 2.896.438 4.628-.013 5.378-1.338 12.365-4.435 17.382-2.625 4.209-3.939 8.648-3.93 12.047.003 2.134.488 3.805 1.385 4.96.9 1.149 2.287 1.908 4.415 1.916.901-.008 1.511-.3 2.036-.814.522-.517.967-1.323 1.318-2.425.709-2.194.97-5.476.964-9 .002-5.523-.59-11.602-.594-15.703.005-1.425.06-2.605.312-3.62.303-1.175.581-2.008.935-2.675.341-.662.855-1.18 1.395-1.373.353-.133.667-.148.93-.15v2.753a.906.906 0 00-.29.029c-.026.015-.017-.001-.08.072-.124.134-.444.779-.795 2.184-.125.46-.211 1.486-.207 2.78-.003 3.803.592 9.967.594 15.703-.001 2.763-.135 5.44-.57 7.788-.44 2.337-1.174 4.415-2.542 5.79a4.69 4.69 0 01-3.379 1.413h-.027z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FED107",
    d: "M30.547 51.373h21.947v3.325H30.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.572 28.115a8 8 0 018-8h25.234a8 8 0 018 8v9.938a8 8 0 01-8 8H28.572a8 8 0 01-8-8v-9.938z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.018 29.102l-10.769 9.951-5.28-4.99 2.061-2.18 3.242 3.064 8.71-8.049 2.036 2.204z",
    fill: "#F9600A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.103 38.146c-.76-.408-1.389-.566-2.195.027.242.797 1.527 4.468 1.12 5.23-.408.76-1.008.885-1.008.885s.304 1.676.101 2.057c1.328-.402 3.94-1.832 3.273-4.037-.668-2.205-1.29-4.162-1.29-4.162z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69 29.325c1.147-2.146 4.348-6.133 6.031-7.28l.837 2.762s-3.191 3.635-3.13 5.85c-1.73-.926-3.739-1.332-3.739-1.332z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.402 29.974c-.79 1.476-3.552 5.638-1.233 8.184 2.317 2.546 2.17 5.375 2.62 6.863.45 1.488.923 3.046 1.701 2.81.78-.236 2.218-.594 2.926-.809-.24-5.901-2.517-5.502-2.365-6.786.153-1.283 2.51-4.356 5.047-2.997.964-1.8.197-3.695-8.696-7.265z",
    fill: "#FED107"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFuelingCompleted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "fueling-completed.daf8a8e76f91acd6dcdb43e699c0d8db.svg";